import { createFileRoute } from "@tanstack/react-router";
import { ComboImersoesContent, COMBO_FAQ } from "@/components/funis/ComboImersoesContent";

const CHECKOUT_URL_DEFAULT = "https://chk.eduzz.com/Q9N5Z2BP01?pf=1&df=1&utm_source=funil-tmanual";

export const Route = createFileRoute("/funil-tmanual-combo-imersoes")({
  head: () => ({
    meta: [
      { title: "Seu curso de Terapia Manual foi enviado! · Combo Imersões R$9,90" },
      { name: "description", content: "O seu curso gratuito de Terapia Manual Ortopédica já está no e-mail. Aproveite o Combo Imersões da FEO por R$9,90." },
      { property: "og:title", content: "Combo Imersões FEO por R$9,90" },
      { property: "og:description", content: "07 Imersões da FEO por R$9,90. Oferta exclusiva pós-inscrição no curso de Terapia Manual." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex,nofollow" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMBO_FAQ.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
        }),
      },
    ],
  }),
  component: () => <ComboImersoesContent defaultCheckoutUrl={CHECKOUT_URL_DEFAULT} />,
});
